import { statusMap } from '../common/helpers';

// Problem types supported by AssetProblemIntakeForm's summary field.
export const PROBLEM_TYPES = [
    'accident',
    'mechanicalFailure',
    'routineMaintenance',
    'warranty',
    'dotViolation',
    'safetyIssue',
];

// Reuses the shared label map rather than duplicating the strings.
export const problemTypeLabel = (type) => statusMap[type] || type;

const PROBLEM_TYPE_HUES = {
    accident: 4,
    mechanicalFailure: 210,
    routineMaintenance: 145,
    warranty: 270,
    dotViolation: 35,
    safetyIssue: 0,
};

// Stable chart color per problem type so legends/bars/donut stay consistent.
export const problemTypeChartColor = (type) => {
    const hue = PROBLEM_TYPE_HUES[type] ?? 200;
    return `hsl(${hue}, 65%, 50%)`;
};
